const axios = require('axios')

class EmilyClient {
  /**
   * Create an EmilyClient
   * @param {string} baseURL - baseURL is prepended to the url and is based on environment
   */
  constructor(baseURL) {
    if (!baseURL)
      throw Error('failed to initialize EmilyClient: missing baseURL')

    this.client = axios.create({
      baseURL,
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
        'Cache-Control': 'no-cache',
      },
    })
  }

  getForm(formGuid) {
    return this.client.get(`/api/external/getForm/${formGuid}`)
  }

  // The current Emily integration/version required data to be urlencoded instead of JSON
  static encodeFormData(formData) {
    return Object.keys(formData)
      .map(
        (key) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(formData[key])}`
      )
      .join('&')
      .replace(/%20/g, '+')
  }

  submit(data) {
    return this.client.post(
      '/api/lead-submit',
      EmilyClient.encodeFormData(data)
    )
  }
}

module.exports = EmilyClient
